import omit from 'lodash/omit';

import type { JobProfileLegacy } from '~/shared/data-contract/job-profile';

import type { ProfileTasksUpdateTransport } from './profile-task-transport';

export type JobProfileLegacyUpdatePayload = Omit<JobProfileLegacy, 'tasks'> & {
    readonly versionComment?: string;
};

export type JobProfileUpdatePayload = {
    readonly jobProfile: {
        readonly sectionTags: JobProfileLegacy['sectionTags'];
        readonly skills: JobProfileLegacy['skills'];
        readonly state: JobProfileLegacy['state'];
        readonly translations: JobProfileLegacy['translations'];
        readonly versionComment?: string;
    };
    readonly tasks?: ProfileTasksUpdateTransport;
    readonly tasksBaseVersion?: number;
};

export const createJobProfileLegacyUpdatePayload = (
    jobProfile: JobProfileLegacy,
    versionComment: string | undefined,
): JobProfileLegacyUpdatePayload => ({
    // The read model's tasks are not a valid tasks block; the endpoint would reject or reapply them.
    ...omit(jobProfile, 'tasks'),
    versionComment,
});

export const createJobProfileUpdatePayload = (
    jobProfile: JobProfileLegacy,
    versionComment: string | undefined,
    tasks?: ProfileTasksUpdateTransport,
    tasksBaseVersion?: number,
): JobProfileUpdatePayload => ({
    jobProfile: {
        sectionTags: jobProfile.sectionTags,
        skills: jobProfile.skills,
        state: jobProfile.state,
        translations: jobProfile.translations,
        versionComment,
    },
    ...(tasks === undefined ? {} : { tasks }),
    ...(tasks === undefined || tasksBaseVersion === undefined ? {} : { tasksBaseVersion }),
});
